const utf8Decoder = new TextDecoder();
export function bytesToString(...bytes: number[]): string {
  return utf8Decoder.decode(new Uint8Array(bytes));
}
